import { Box, Button, Drawer, DrawerContent,  DrawerOverlay, Heading, Image, Text,  useDisclosure,  VStack } from "@chakra-ui/react"
import React from 'react'
import { BsChevronRight,BsArrowUpRight } from "react-icons/bs"
function DrawerInspiration() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  
    return (
      <>
        <Button   variant="link" size="md" colorScheme="black"  onMouseEnter={onOpen}>
          Inspiration
        </Button>
        <Drawer
          size="md"
          isOpen={isOpen}
          placement='left'
          onClose={onClose}
        >
          <DrawerOverlay />
          <DrawerContent>
            <Box scrollTop="0px" overflowY="scroll" p="1rem" bgColor="#efeeea">
                <VStack spacing={"2rem"} align='stretch'>
                  <Box pb="2rem" borderBottom="1px solid grey">
                    <VStack spacing={"1.5rem"} align='stretch'>
                        <Box display="flex" alignItems="center">
                            <Image width="150px" src="https://logos-world.net/wp-content/uploads/2021/02/Mailchimp-Logo-2018-present.png" alt=""/>
                            <Text fontSize="20px" pr="5px" pl="5px">Presents</Text>
                            <BsArrowUpRight color="teal" fontSize="20px"/>
                        </Box>
                        <Box _hover={{color:"teal", cursor:"pointer"}} display="flex" alignItems="center" justifyContent="space-between">
                            <Heading as="h1"  size="lg" fontWeight="400">Podcasts</Heading>
                            <BsChevronRight fontSize="30px"/>
                        </Box>
                        <Box _hover={{color:"teal", cursor:"pointer"}} display="flex" alignItems="center" justifyContent="space-between">
                            <Heading as="h1"  size="lg" fontWeight="400">Series</Heading>
                            <BsChevronRight fontSize="30px"/>
                        </Box>
                        <Box _hover={{color:"teal", cursor:"pointer"}} display="flex" alignItems="center" justifyContent="space-between">
                            <Heading as="h1"  size="lg" fontWeight="400">Films</Heading>
                            <BsChevronRight fontSize="30px"/>
                        </Box>
                    </VStack> 
                  </Box>
                  <Box pb="2rem" borderBottom="1px solid grey">
                    <VStack spacing={"1.5rem"} align='stretch'>
                        <Box display="flex" alignItems="center">
                            <Image width="200px" pr="3px" src="https://user-images.githubusercontent.com/99709824/179729907-77336999-d0d6-46bd-9e50-02757d1b8506.png" alt=""/>
                            <BsArrowUpRight color="teal" fontSize="24px"/>
                        </Box>
                        <Box _hover={{color:"teal", cursor:"pointer"}} display="flex" alignItems="center" justifyContent="space-between">
                            <Heading as="h1"  size="lg" fontWeight="400">Expert Insights</Heading>
                            <BsChevronRight fontSize="30px"/>
                        </Box>
                        <Box _hover={{color:"teal", cursor:"pointer"}} display="flex" alignItems="center" justifyContent="space-between">
                            <Heading as="h1"  size="lg" fontWeight="400">Industry Trends</Heading>
                            <BsChevronRight fontSize="30px"/>
                        </Box>
                        <Box _hover={{color:"teal", cursor:"pointer"}} display="flex" alignItems="center" justifyContent="space-between">
                            <Heading as="h1"  size="lg" fontWeight="400">Smart Living</Heading>
                            <BsChevronRight fontSize="30px"/>
                        </Box>
                    </VStack> 
                  </Box>
                  <Box>
                    <VStack spacing={"1.5rem"} align='stretch'>
                      <Heading _hover={{color:"teal", cursor:"pointer"}} as="h1"  size="lg" fontWeight="400">Talk to Sales: +1(800)315-5939</Heading>
                    </VStack>
                  </Box>
                </VStack>
            </Box>
          </DrawerContent>
        </Drawer>
      </>
    )
  }
  export default DrawerInspiration